var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19081_956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.334 18.5C23.334 20.7091 21.5431 22.5 19.334 22.5H12.334C10.1248 22.5 8.33398 20.7091 8.33398 18.5V15.5625H23.334V18.5ZM11.334 18.75C10.9198 18.75 10.584 19.0858 10.584 19.5C10.584 19.9142 10.9198 20.25 11.334 20.25C11.7482 20.25 12.084 19.9142 12.084 19.5C12.084 19.0858 11.7482 18.75 11.334 18.75ZM23.3096 12.5625C23.3252 12.7062 23.334 12.8521 23.334 13V14.4375H8.33398V13C8.33398 12.8521 8.34276 12.7062 8.3584 12.5625H23.3096ZM19.334 9C20.9886 9 22.408 10.0049 23.0166 11.4375H8.65137C9.25997 10.0049 10.6794 9 12.334 9H19.334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19081_956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalWallet);
export default __webpack_public_path__ + "static/media/digital_wallet.7ce9b124ff0ada451efc8c93cb796dd7.svg";
export { ForwardRef as ReactComponent };